<div class="text-end mb-1 w-100">
	<i (click)="closeDialog()" role="button" class="fs-3 fas fa-times closeOfferChange"></i>
</div>
<div class="d-flex flex-column align-items-center border border-1 py-2 mb-3">
	<div class="d-flex mb-1">
		<h5>{{ data.selectedOffer?.product?.name }}</h5>
		<h5>
			{{ data.selectedOffer?.dateRange.lower
			}}<span *ngIf="data.selectedOffer?.dateRange.lower !== data.selectedOffer?.dateRange.upper"
				>-{{ data.selectedOffer?.dateRange.upper }}</span
			>
			(<span *ngIf="data.selectedOffer?.nightsStay !== 0">{{ data.selectedOffer?.nightsStay }} </span
			>{{ nights }})
		</h5>
	</div>
	<div class="d-flex">
		<h5>{{ data.selectedOffer?.roomType?.name }}</h5>
		<h5>{{ data.selectedOffer?.stop.name }}</h5>
		<h5>{{ data.selectedOffer?.board?.name }}</h5>
	</div>
</div>
<!-- Commented, not deleted, because it is possible that someday the business will want to come back to it -->
<!-- @if (displayChangedTransportDepartureMessage()) {
	<div class="alert alert-danger">
		Co najmniej jedno miasto wyjazdu zostało zmienione. Po zaakceptowaniu zmian, klient otrzyma e-mail z informacją
		o zaktualizowanych szczegółach dotyczących miasta wyjazdu.
	</div>
} -->
<div
	style="height: 500px"
	[ngClass]="{
		'overflow-x-hidden': table.offsetHeight < table.scrollHeight,
	}"
	#table
>
	<table *ngIf="!loading; else spinner" class="w-100 fixed_header">
		<thead>
			<tr *ngIf="offerOrConfigView; else offerChange">
				<td class="text-center p-0" style="width: 300px">Uczestnik</td>
				<th class="name" style="width: 486px">Nazwa</th>
				<td class="text-center p-0 w-prices">Cena</td>
			</tr>
			<ng-template #offerChange>
				<tr>
					<th class="text-center p-0 w-prices">Uczestnik</th>
					<th class="name">Nazwa</th>
					<th class="text-center p-0 w-prices">Kwota</th>
					<th class="text-center p-0 w-prices">Nowa cena</th>
					<th class="text-center p-0 w-prices">Różnica</th>
				</tr>
			</ng-template>
		</thead>
		<tbody>
			<ng-container *ngFor="let slot of data.currentOffer?.slot; let slotIndex = index">
				<tr [ngClass]="{ 'slot-removed': !slot.active }">
					<td
						class="text-center rowSpan p-0"
						[style.width]="offerOrConfigView ? '300px' : '150px'"
						[rowSpan]="slot.slotServices.length + rowNumber - 1"
					>
						<span
							*ngIf="!slot.active && data.selectedOffer.board.additionalRoomSizeCharge"
							style="font-weight: 600; color: black"
						>
							Dopłata:
							{{
								data.selectedOffer.board.additionalRoomSizeCharge * data.selectedOffer.nightsStay
									| price
							}}
							PLN
							<br />
						</span>
						<div *ngIf="slot.userData && data.currentOffer.type !== OfferChangeTypes.ADD; else emptyUser">
							{{ slot.userData.firstName }}
							{{ slot.userData.lastName }}
						</div>
						<ng-template #emptyUser
							><span>Uczestnik {{ slotIndex + 1 }}</span></ng-template
						>
						<br />
						<button
							(click)="changeSlotActiveState(slot)"
							class="mt-1"
							mat-raised-button
							[color]="slot.active ? 'warn' : 'accent'"
						>
							<span *ngIf="slot.active; else slotDisableButton">Usuń <i class="fas fa-trash"></i> </span>
							<ng-template #slotDisableButton> Przywróć <i class="fas fa-undo"></i> </ng-template>
						</button>
					</td>
					<td [style.width]="offerOrConfigView ? '486px' : '336px'" class="name">
						<span *ngIf="offerOrConfigView; else changeOfferRoomType">
							<ng-select
								class="pb-2"
								appearance="outline"
								[multiple]="false"
								placeholder="Wybierz pokój"
								[clearable]="false"
								[ngModel]="data.selectedOffer?.roomType?.name"
								(ngModelChange)="calculateRoomTypePrices($event)"
								appendTo="body"
							>
								@for (sellAccommodation of sellAccommodations$ | async; track sellAccommodation.id) {
									<ng-option [value]="sellAccommodation?.name">{{
										sellAccommodation.name
									}}</ng-option>
								}
							</ng-select>
						</span>
						<ng-template #changeOfferRoomType>
							<span
								[ngClass]="{
									'text-danger':
										data.currentOffer?.roomType?.name !== data.selectedOffer?.roomType?.name,
								}"
							>
								{{ data.currentOffer?.roomType?.name }}
							</span>
							<ng-container
								*ngIf="data.currentOffer?.roomType?.name !== data.selectedOffer?.roomType?.name"
							>
								<i class="fas fa-arrow-right px-1"></i>
								<span class="text-success">
									{{ data.selectedOffer?.roomType?.name }}
								</span></ng-container
							>
						</ng-template>
					</td>
					<td
						[ngClass]="{
							'd-none': offerOrConfigView,
						}"
						class="text-center p-0 w-prices"
					>
						{{ slot.catalogPrice - slot.promotionValue | price }}
					</td>
					<td class="text-center p-0 w-prices">
						<input
							[ngClass]="{ 'slot-removed': !slot.active }"
							class="w-100 bg-light text-black"
							type="number"
							[disabled]="true"
							(change)="calculateNewPrices(slot)"
							[ngModel]="slot.newPrice ? (slot.newPrice | price) : null"
							(ngModelChange)="slot.newPrice = convertPriceToGrosze($event)"
						/>
					</td>
					<td
						[ngClass]="{
							'bg-danger': slot.newPrice - (slot.catalogPrice - slot.promotionValue) < 0,
							'bg-success': slot.newPrice - (slot.catalogPrice - slot.promotionValue) > 0,
							'd-none': offerOrConfigView,
						}"
						class="text-center bg-opacity-50 p-0 w-prices"
					>
						{{ slot.newPrice - (slot.catalogPrice - slot.promotionValue) | price }}
					</td>
				</tr>
				<tr [ngClass]="{ 'slot-removed': !slot.active }">
					<td class="name">
						<span *ngIf="offerOrConfigView; else changeOfferBoard">
							<ng-select
								class="pb-2"
								appearance="outline"
								[multiple]="false"
								placeholder="Wybierz wyżywienie"
								[clearable]="false"
								[ngModel]="data.selectedOffer?.board?.name"
								(ngModelChange)="calculateBoardPrices($event)"
								appendTo="body"
							>
								@for (board of boards$ | async; track board.id) {
									<ng-option [value]="board.board.name">{{ board.board.name }}</ng-option>
								}
							</ng-select>
						</span>
						<ng-template #changeOfferBoard>
							<span
								[ngClass]="{
									'text-danger': data.currentOffer?.board?.name !== data.selectedOffer?.board?.name,
								}"
							>
								{{ data.currentOffer?.board?.name }}
							</span>
							<ng-container *ngIf="data.currentOffer?.board?.name !== data.selectedOffer?.board?.name">
								<i class="fas fa-arrow-right px-1"></i>
								<span class="text-success">
									{{ data.selectedOffer?.board?.name }}
								</span></ng-container
							>
						</ng-template>
					</td>
					<td
						[ngClass]="{
							'd-none': offerOrConfigView,
						}"
						class="text-center p-0 w-prices"
					>
						{{ slot.priceBoard | price }}
					</td>
					<td class="text-center p-0 w-prices">
						<input
							[ngClass]="{ 'slot-removed': !slot.active }"
							class="w-100 text-black"
							(change)="selectPromotion(data.selectedOffer.promotion.id)"
							[disabled]="disableInputState"
							type="number"
							[ngModel]="slot.newBoardPrice ? (slot.newBoardPrice | price) : 0"
							(ngModelChange)="slot.newBoardPrice = convertPriceToGrosze($event)"
						/>
					</td>
					<td
						[ngClass]="{
							'd-none': offerOrConfigView,
							'bg-danger': slot.newBoardPrice - slot.priceBoard < 0,
							'bg-success': slot.newBoardPrice - slot.priceBoard > 0,
						}"
						class="text-center bg-opacity-50 p-0 w-prices"
					>
						{{ slot.newBoardPrice - slot.priceBoard | price }}
					</td>
				</tr>
				<tr [ngClass]="{ 'slot-removed': !slot.active }">
					<td [colSpan]="offerOrConfigView ? 2 : 4">
						<div class="d-flex justify-content-between">
							<div class="w-50 d-flex align-items-center stop-row">Miasto wyjazdu:</div>
							<ng-select
								style="width: 50%"
								class="pb-2"
								appearance="outline"
								(change)="transportChange()"
								[multiple]="false"
								[disabled]="!slot.active"
								placeholder="Wybierz miasto"
								[clearable]="
									slot.selectedStopDeparture?.name !== OWN_TRANSPORT_NAME &&
									slot.selectedStopDeparture?.name !== NO_TRANSPORT_NAME
								"
								[ngModel]="slot.selectedStopDeparture?.name"
								(ngModelChange)="calculateTransportPrices($event, slot, 'departure')"
								appendTo="body"
							>
								<ng-option *ngFor="let stop of stops" [value]="stop?.name"
									>{{ stop.name }} |
									{{ stop.fees.departure | price }}
									PLN</ng-option
								>
							</ng-select>
						</div>
					</td>
				</tr>
				<tr [ngClass]="{ 'slot-removed': !slot.active }">
					<td [colSpan]="offerOrConfigView ? 2 : 4">
						<div class="d-flex justify-content-between">
							<div class="w-50 d-flex align-items-center stop-row">Miasto powrotu:</div>
							<ng-select
								style="width: 50%"
								class="pb-2"
								appearance="outline"
								(change)="transportChange()"
								[disabled]="!slot.active"
								[multiple]="false"
								[clearable]="
									slot.selectedStopReturn?.name !== OWN_TRANSPORT_NAME &&
									slot.selectedStopReturn?.name !== NO_TRANSPORT_NAME
								"
								[ngModel]="slot.selectedStopReturn?.name"
								(ngModelChange)="calculateTransportPrices($event, slot, 'return')"
								placeholder="Wybierz miasto"
								appendTo="body"
							>
								<ng-option *ngFor="let stop of stops" [value]="stop?.name"
									>{{ stop.name }} |
									{{ stop.fees.return | price }}
									PLN</ng-option
								>
							</ng-select>
						</div>
					</td>
				</tr>
				<tr
					*ngFor="let service of slot?.slotServices; let i = index"
					[ngClass]="{
						'service-disable': !service.active,
						'slot-removed': !slot.active,
					}"
				>
					<td class="name">{{ service.service?.name }}</td>
					<td
						[ngClass]="{
							'd-none': offerOrConfigView,
						}"
						class="text-center p-0 w-prices"
					>
						{{ service?.price ? (service.price | price) : 'BRAK' }}
					</td>
					<td class="text-center position-relative p-0 w-prices">
						<!-- <div *ngIf="offerOrConfigView" class="change-active-btn right-0">
							<i
								role="button"
								(click)="changeActiveStatus(this.data.currentOffer.slot[slotIndex], i)"
								[ngClass]="{
									'fa-times-circle': service.active,
									'text-remove': service.active,
									'fa-undo': !service.active,
								}"
								class="fas"
							></i>
						</div> -->
						<ng-container *ngIf="service.newPrice !== 0">
							<input
								class="w-100 text-black"
								[ngClass]="{
									'price-input': service.active,
									'service-disable': !service.active,
								}"
								(change)="calculateNewPrices(slot)"
								[disabled]="true"
								type="number"
								[ngModel]="service.newPrice ? (service.newPrice | price) : null"
								(ngModelChange)="service.newPrice = convertPriceToGrosze($event)"
							/>
						</ng-container>
						<ng-container *ngIf="service.newPrice === 0"> BRAK </ng-container>
					</td>
					<td
						[ngClass]="{
							'd-none': offerOrConfigView,
							'bg-danger': service.newPrice - service.price < 0 && service.active,
							'bg-success': service.newPrice - service.price > 0 && service.active,
						}"
						class="text-center position-relative bg-opacity-50 p-0 w-prices"
					>
						{{ service.newPrice - service.price | price }}
						<!-- <div *ngIf="slot.active" class="change-active-btn right-0">
							<i
								role="button"
								(click)="changeActiveStatus(this.data.currentOffer.slot[slotIndex], i)"
								[ngClass]="{
									'fa-times-circle': service.active,
									'text-remove': service.active,
									'fa-undo': !service.active,
								}"
								class="fas"
							></i>
						</div> -->
					</td>
				</tr>
				<tr>
					<td>Wyrównanie ceny</td>
					<td [colSpan]="offerOrConfigView ? 1 : 3">
						<input
							class="w-100 text-black"
							type="number"
							[ngClass]="{ 'slot-removed': !slot.active }"
							[disabled]="!slot.active"
							[ngModel]="slot.priceAdjustment ? (slot.priceAdjustment | price) : 0"
							(ngModelChange)="slot.priceAdjustment = convertPriceToGrosze($event)"
							(change)="calculateNewPrices(slot)"
						/>
					</td>
				</tr>
				<!-- Commented, not deleted — service adding moved to reservation-services-dialog
				<tr [ngClass]="{ 'slot-removed': !slot.active }">
					<td>
						<ng-select
							appearance="outline"
							[multiple]="false"
							[disabled]="!slot.active"
							placeholder="Wpisz nazwę"
							appendTo="body"
							[(ngModel)]="slot.selectedService"
							class="my-select pb-2"
						>
							<ng-option
								class="my-option"
								*ngFor="let service of slot?.servicesToAdd"
								[value]="service"
								>{{ service?.name }}</ng-option
							>
						</ng-select>
					</td>
					<td [colSpan]="offerOrConfigView ? 1 : 3">
						<button
							class="btn-service"
							mat-raised-button
							[disabled]="!slot.active"
							color="accent"
							(click)="addService(slotIndex, slot?.selectedService)"
						>
							Dodaj usługę
						</button>
					</td>
				</tr>
				-->
				<tr [ngClass]="{ 'slot-removed': !slot.active }" class="fw-bolder">
					<td class="text-end">SUMA</td>
					<td
						[ngClass]="{
							'd-none': offerOrConfigView,
						}"
						class="text-center p-0 w-prices"
					>
						{{ slot.totalPrice | price }} PLN
					</td>
					<td class="text-center p-0 w-prices">
						{{ slot.newTotalPrice ?? 0 | price }}
						PLN
					</td>
					<td
						[ngClass]="{
							'd-none': offerOrConfigView,
							'bg-danger': slot.newTotalPrice - slot.totalPrice < 0,
							'bg-success': slot.newTotalPrice - slot.totalPrice > 0,
						}"
						class="text-center bg-opacity-50 p-0 w-prices"
					>
						{{ slot.newTotalPrice - slot.totalPrice | price }}
						PLN
					</td>
				</tr>
			</ng-container>
			<tr>
				<td class="text-center p-0" rowspan="2" [style.width]="offerOrConfigView ? '300px' : '150px'">
					Oferta
				</td>
				<td>
					<ng-select
						appearance="outline"
						[multiple]="false"
						placeholder="Promocja"
						[ngModel]="data.selectedOffer.promotion?.id"
						(ngModelChange)="selectPromotion($event)"
						appendTo="body"
						class="pb-2 promotion-select"
					>
						<ng-option *ngFor="let promotion of promotions" class="promotion-option" [value]="promotion.id"
							>{{ promotion?.catalog?.name }}
							<ng-container *ngIf="promotion.method === PaymentTermCountKind.PERCENTAGE; else ValueKind"
								>{{ promotion.methodValue | PercentValue }}%</ng-container
							><ng-template #ValueKind>{{ promotion.methodValue | price }} PLN</ng-template>
						</ng-option>
					</ng-select>
				</td>
				<td class="fw-bolder text-center p-0" [colSpan]="offerOrConfigView ? 1 : 3">
					<ng-container *ngIf="data.selectedOffer.promotionValue; else noPromotion">
						-{{ data.selectedOffer.promotionValue | price }}
						PLN
					</ng-container>
					<ng-template #noPromotion> BRAK </ng-template>
				</td>
			</tr>

			<tr>
				<td>
					@if (insurances().length) {
						<ng-select
							appearance="outline"
							[multiple]="false"
							placeholder="Ubezpieczenie"
							[ngModel]="data.selectedOffer.insurance"
							(ngModelChange)="selectInsurance($event)"
							appendTo="body"
							class="pb-2 promotion-select"
						>
							@for (insurance of insurances(); track insurance.id) {
								<ng-option [value]="insurance">
									{{ insurance.name }}
								</ng-option>
							}
						</ng-select>
					}
				</td>
				<td class="fw-bolder text-center p-0" [colSpan]="offerOrConfigView ? 1 : 3">
					{{ insurancePrice() | price }} PLN
				</td>
			</tr>
		</tbody>
	</table>
	<ng-template #spinner>
		<div class="d-flex justify-content-center align-items-center h-100">
			<mat-spinner diameter="100"></mat-spinner>
		</div>
	</ng-template>
</div>

<div class="d-flex justify-content-end align-items-center my-3 fw-bold summary">
	<p class="m-0 pe-2 fs-5">ŁĄCZNA KWOTA:</p>
	<p *ngIf="data.currentOffer.type === OfferChangeTypes.CHANGE" class="w-prices text-center m-0 fs-5">
		<i class="fas fa-info-circle text-secondary" matTooltip="Kwota" matTooltipPosition="above"></i>
		{{ data.currentOffer?.totalPrice | price }} PLN
	</p>
	<p class="w-prices text-center m-0 fs-5">
		<i
			*ngIf="data.currentOffer.type === OfferChangeTypes.CHANGE"
			class="fas fa-info-circle text-secondary"
			matTooltip="Nowa cena"
			matTooltipPosition="above"
		></i>
		{{ data.currentOffer?.newTotalPrice ?? 0 | price }}
		PLN
	</p>
	<p *ngIf="data.currentOffer.type === OfferChangeTypes.CHANGE" class="w-prices text-center m-0 fs-5">
		<i class="fas fa-info-circle text-secondary" matTooltip="Różnica" matTooltipPosition="above"></i>
		{{ data.currentOffer?.newTotalPrice - data.currentOffer?.totalPrice | price }}
		PLN
	</p>
</div>

<div class="d-flex justify-content-end align-items-center">
	<div class="d-flex align-items-center">
		<button
			(click)="additionalRoomSizeCharge ? openConfirmChangeDialog() : checkTransportAndRoomAvailability()"
			class="w-btn h-btn confirm-btn"
			mat-raised-button
			[disabled]="isRequestPending || !data.selectedOffer.insurer"
			color="primary"
		>
			Potwierdzam
		</button>
	</div>
</div>
